// ** Logo
import logo from '@src/assets/images/zamzam/Fatwa_Centre_Icon.png'

const SpinnerComponent = () => {
  return (
    <div className='fallback-spinner z-index-5 spinnerIndex' >
      <img className='fallback-logo' src={logo} alt='logo' />
      <div className='loading'>
        <div className='effect-1 effects'></div>
        <div className='effect-2 effects'></div>
        <div className='effect-3 effects'></div>
      </div>
    </div>
  )
}

export default SpinnerComponent
